
export const filebasic = {

  filegroup: {
    service: {
      name: 'filegroup',
      title: 'File Group',
    }
  },

  paramgroup: {
    service: {
      name: 'paramgroup',
      title: 'Parameter Group',
    }
  },

  paramstatus: {
    service: {
      name: 'paramstatus',
      title: 'Parameter Status',
    }
  },

};
